// HTML titles
export const WHTML_001 = 'Saisie de l\'identifiant | Mot de passe oublié Orange';
export const WHTML_002 = 'Choix du moyen de contact | Mot de passe oublié Orange';
export const WHTML_003 = 'Saisie du code postal, envoi par courrier | Mot de passe oublié Orange';
export const WHTML_004 = 'Saisie du code | Mot de passe oublié Orange';
export const WHTML_005 = 'Réinitialisation du mot de passe | Mot de passe oublié Orange';
export const WHTML_006 = 'Validation des moyens de contact | Mot de passe oublié Orange';
export const WHTML_007 = 'Confirmation du changement de mot de passe | Mot de passe oublié Orange';
export const WHTML_008 = 'Désolé, nous ne pouvons pas répondre à votre demande | Mot de passe oublié Orange';
export const WHTML_009 = 'Une demande de mot de passe provisoire est déjà en cours | Mot de passe oublié Orange';
export const WHTML_010 = 'Votre demande de mot de passe provisoire est prise en compte | Mot de passe oublié Orange';
export const WHTML_011 = 'Contactez le titulaire de l\'abonnement internet Orange | Mot de passe oublié Orange';
export const WHTML_012 = 'Contactez le service client Orange | Mot de passe oublié Orange';
export const WHTML_013 = 'Vérification du moyen de contact | Mot de passe oublié Orange';

// Global titles
export const WLOST_001 = 'Modifier votre mot de passe';
export const WLOST_002 = 'Recevoir un mot de passe provisoire par courrier';
export const WLOST_006 = 'Modifier votre mot de passe';

// Stepbar
export const WLOST_010 = 'Vérification';
export const WLOST_011 = 'Nouveau mot de passe';
export const WLOST_012 = 'Moyens de contact';
export const WLOST_013 = 'Terminé';

// Login
export const WLOST_101 = 'Indiquez votre compte Orange';
export const WLOST_102 = 'Indiquez l\'adresse e-mail ou le numéro de mobile du compte Orange pour lequel vous souhaitez créer votre nouveau mot de passe.';
export const WLOST_103 = 'Adresse e-mail ou n° de mobile Orange';
export const WLOST_104 = 'Vérifiez la saisie de votre compte Orange (adresse email ou n° de mobile).';
export const WLOST_105 = 'Le compte Orange saisi n’est pas valide.';
export const WLOST_106 = 'Comment retrouver l\'adresse e-mail de votre compte';
export const WLOST_107 = 'Saisissez votre compte Orange (adresse email ou n° de mobile).';

// Captcha
export const WLOST_110 = 'Cliquez sur les photos dans l’ordre indiqué :';
export const WLOST_111 = 'Veuillez terminer en cliquant sur les photos dans l\'ordre indiqué.';
export const WLOST_112 = 'Veuillez cliquer sur les photos dans l\'ordre indiqué.';
export const WLOST_113 = 'Supprimer mon choix d\'image pour la catégorie';
export const WLOST_114 = 'Vérifions ensemble que vous n\'êtes pas un robot';

// Access errors
export const WLOST_120 = 'Pour accéder à votre Espace client';
export const WLOST_121 = 'Le mot de passe provisoire de votre Espace client est votre n° client visible sur votre facture (10 chiffres à saisir sans espace).\nPour des raisons de sécurité, vous devez utiliser votre mot de passe provisoire lors de votre 1ère connexion à votre Espace client.';
export const WLOST_122 = 'Merci de vous reconnecter ultérieurement à votre Espace client avec votre mot de passe provisoire (votre n° client visible sur votre facture, 10 chiffres à saisir sans espace).';
export const WLOST_123 = 'Accès restreint';
export const WLOST_124 = 'Pour des raisons de sécurité, la réinitialisation de votre mot de passe n\'est pas autorisée depuis votre lieu actuel de connexion à internet (adresse IP).';
export const WLOST_125 = 'Service non autorisé';
export const WLOST_126 = 'Vous n’avez pas les droits pour accéder au service de récupération du mot de passe.';

// Choose contact to receive OTC
export const WLOST_200 = 'Pour vérifier que ce compte vous appartient';
export const WLOST_201 = 'Recevez votre code de réinitialisation';
export const WLOST_202 = 'Vous pourrez ensuite créer votre mot de passe de façon sécurisée.';
export const WLOST_203 = 'Par SMS';
export const WLOST_204 = 'Par email';

// Can not use contacts
export const WLOST_205 = 'Vous ne pouvez pas utiliser ce numéro de mobile ?';
export const WLOST_206 = 'Vous ne pouvez pas utiliser cette adresse email ?';
export const WLOST_207 = 'Vous ne pouvez pas utiliser ces moyens de contact ?';
export const WLOST_208 = 'Pour accéder de nouveau à vos services Orange.';

// Ask new temporary password with letter
export const WLOST_210 = 'Demandez un nouveau mot de passe provisoire';
export const WLOST_211 = 'Vous le recevrez par courrier dans un délai de 7 jours ouvrés en France métropolitaine ou 15 jours ouvrés dans les départements et régions d\'outre-mer.';
export const WLOST_212 = 'Recevoir un nouveau mot de passe provisoire par courrier';
export const WLOST_213 = 'Si vous appelez le service client, nos conseillers vous proposeront la même solution : l\'envoi par courrier d’un nouveau mot de passe provisoire.';

// Use temporary password
export const WLOST_220 = 'Utilisez le mot de passe provisoire communiqué par Orange';
export const WLOST_221 = 'Il est indiqué sur le document "Pour accéder à vos services Orange" envoyé à votre demande. Vous pourrez ensuite créer votre mot de passe de façon sécurisée.';
export const WLOST_222 = 'Saisir votre mot de passe provisoire';

// Ask letter
export const WLOST_230 = 'Indiquez les 2 premiers chiffres du code postal de l\'adresse où est installée la Livebox. Vous recevrez le mot de passe provisoire à cette adresse dans un délai de 7 jours ouvrés en France métropolitaine ou 15 jours ouvrés dans les départements et régions d\'outre-mer.';
export const WLOST_231 = '2 premiers chiffres de votre code postal';
export const WLOST_232 = 'Veuillez saisir les 2 premiers chiffres de votre code postal de votre adresse d’installation.';
export const WLOST_233 = 'Veuillez vérifier la saisie des 2 premiers chiffres de votre code postal de votre adresse d’installation.';
export const WLOST_234 = 'Trop de saisies incorrectes';
export const WLOST_235 = 'Vous avez atteint le maximum de saisies incorrectes.\nVeuillez renouveler votre demande ultérieurement.';
export const WLOST_236 = 'Lorsque les moyens de contact ne sont pas renseignés dans l’espace client, seul le courrier postal permet l’envoi sécurisé d’un mot de passe provisoire. Si vous appelez le service client, nos conseillers vous proposeront la même solution.';

// Confirm letter
export const WLOST_240 = 'Votre demande de mot de passe provisoire est prise en compte.';
export const WLOST_241 = `Vous recevrez un mot de passe provisoire dans un délai de ${window.reactAppEnv.conf.letterDelay.france} jours ouvrés en France métropolitaine ou ${window.reactAppEnv.conf.letterDelay.domTom} jours ouvrés dans les départements et régions d'outre-mer.\nCe mot de passe sera valable 60 jours à compter de votre demande.\nIl vous permettra de personnaliser votre mot de passe pour accéder à votre espace client et vos services Orange.`;

// Pending letter
export const WLOST_250 = 'Une demande de mot de passe provisoire est déjà en cours';
export const WLOST_251 = `Un courrier postal contenant un mot de passe provisoire a déjà été demandé.\nCe courrier postal est envoyé à l'adresse à laquelle  est installée la Livebox.\nVous le recevrez dans un délai de ${window.reactAppEnv.conf.letterDelay.france} jours ouvrés en France métropolitaine ou ${window.reactAppEnv.conf.letterDelay.domTom} jours ouvrés dans les départements et régions d'outre-mer.\nDès réception, vous pourrez vous identifier sur orange.fr et créer votre propre mot de passe.`;

// Not owner account
export const WLOST_260 = 'Contactez le titulaire de l\'abonnement internet Orange';
export const WLOST_261 = 'Vous n\'avez pas renseigné de numéro de mobile ou d\'adresse e-mail pour réinitialiser facilement le mot de passe de ce compte.<br><br>Seul le titulaire de l\'abonnement internet Orange associé à ce compte peut réinitialiser ce mot de passe depuis son espace client.<br><br>Pour une gestion autonome de votre mot de passe, pensez à renseigner vos moyens de contact dans votre espace client.';
export const WLOST_262 = 'Seul le titulaire de l\'abonnement internet Orange correspondant peut réinitialiser ce mot de passe depuis son Espace client.';

// Contact SAV
export const WLOST_270 = `Vous pouvez retrouver votre mot de passe sur le courrier de bienvenue reçu lors de la souscription de votre abonnement internet Orange.<br><br>Si vous avez modifié ce mot de passe ou perdu ce courrier, nous vous invitons à contacter le Service clients. Un mot de passe provisoire vous sera envoyé par courrier dans un délai d’environ ${window.reactAppEnv.conf.letterDelay.france} jours ouvrés.`;
export const WLOST_271 = 'Contactez le service client Orange';

// Livebox contacts
export const WLOST_280 = 'Connectez-vous depuis votre Livebox (wifi/ethernet)';
export const WLOST_281 = 'Vous pourrez ensuite créer votre nouveau mot de passe.';
export const WLOST_282 = `Nous pourrons ainsi vous envoyer en toute sécurité le code à l'adresse e-mail <strong>{email}</strong>.`;
export const WLOST_283 = `Nous pourrons ainsi vous envoyer en toute sécurité le code au <strong>{mobile}</strong>.`;
export const WLOST_284 = `Nous pourrons ainsi vous envoyer en toute sécurité un code au <strong>{mobile}</strong> ou à l'adresse e-mail <strong>{email}</strong>. ${WLOST_281}`;
export const WLOST_285 = `Nous pourrons ainsi vous envoyer en toute sécurité un code à l'adresse e-mail <strong>{email}</strong>. ${WLOST_281}`;
export const WLOST_286 = `Nous pourrons ainsi vous envoyer en toute sécurité un code au <strong>{mobile}</strong>. ${WLOST_281}`;
export const WLOST_287 = `Nous pourrons ainsi vous envoyer en toute sécurité le code au <strong>{mobile}</strong> ou à l'adresse e-mail <strong>{email}</strong>.`;

// default contact
export const WLOST_290 = `Nous vous proposons de vous envoyer par SMS un code de réinitialisation au {defaultContact}.\nVous pourrez ensuite créer votre mot de passe de façon sécurisée.`;
export const WLOST_291 = `Recevoir le code par SMS`;
export const WLOST_292 = `Voir toutes les méthodes de vérification`;


// Use OTC code
export const WLOST_301 = 'Votre code de réinitialisation du mot de passe a été envoyé au ';
export const WLOST_302 = 'Votre code de réinitialisation du mot de passe a été envoyé à ';
export const WLOST_303 = 'Saisissez votre code reçu par SMS';
export const WLOST_304 = 'Saisissez votre code reçu par email';
export const WLOST_305 = 'Ce code à 6 chiffres vous permet de réinitialiser votre mot de passe.';
export const WLOST_306 = 'Veuillez saisir le code de réinitialisation.';
export const WLOST_307 = 'Ce code de réinitialisation comporte uniquement des chiffres.';
export const WLOST_308 = 'Veuillez vérifier la saisie de votre code de réinitialisation.';

// Retry OTC
export const WLOST_310 = 'Un SMS vous a été renvoyé';
export const WLOST_311 = 'Un email vous a été renvoyé';
export const WLOST_312 = 'Renvoyer un code';
export const WLOST_320 = 'Voir toutes les méthodes de vérification';

// OTC errors
export const WLOST_330 = 'Nombre maximum d\'envois du code atteint';
export const WLOST_331 = 'Vous avez atteint le maximum d’envois du code de réinitialisation de mot de passe par SMS.\nNous vous invitons à renouveler votre demande ultérieurement.';
export const WLOST_332 = 'Vous avez atteint le maximum d’envois du code de réinitialisation de mot de passe par email.\nNous vous invitons à renouveler votre demande ultérieurement.';
export const WLOST_333 = 'Trop de saisies incorrectes';
export const WLOST_334 = 'Vous avez atteint le maximum de saisies incorrectes du code de réinitialisation de mot de passe.\nVeuillez renouveler votre demande.';
export const WLOST_335 = 'Le code de réinitialisation a expiré';
export const WLOST_336 = 'Le code de réinitialisation qui vous a été envoyé n’est plus valide.\nNous vous invitons à renouveler votre demande.';

// Change password
export const WLOST_400 = 'Créez votre mot de passe';
export const WLOST_401 = 'Nouveau mot de passe';
export const WLOST_402 = 'Confirmation du mot de passe';
export const WLOST_403 = 'Veuillez saisir votre nouveau mot de passe';
export const WLOST_404 = 'Veuillez confirmer votre mot de passe';
export const WLOST_405 = 'Les 2 saisies ne correspondent pas';
export const WLOST_406 = 'L’identifiant n’est pas un mot de passe valide';
export const WLOST_407 = 'Veuillez choisir un mot de passe différent du mot de passe actuel';
export const WLOST_408 = 'Mot de passe trop court';
export const WLOST_409 = 'Mot de passe trop long';
export const WLOST_410 = 'L’espace n’est pas autorisé';
export const WLOST_411 = 'Les caractères accentués ne sont pas autorisés';
export const WLOST_412 = 'Les caractères spéciaux ne sont pas autorisés';

// CNIL rules
export const WLOST_413 = 'Pas d\'espace';
export const WLOST_414 = 'Au moins 8 caractères';
export const WLOST_415 = 'Au moins 1 minuscule';
export const WLOST_416 = 'Au moins 1 majuscule';
export const WLOST_417 = 'Au moins 1 chiffre';

// Modal update password
export const WLOST_418 = 'Mise à jour de votre mot de passe en cours';

// Password timeout
export const WLOST_420 = 'Votre nouveau mot de passe sera disponible dans 30 minutes';
export const WLOST_421 = 'Passé ce délai, vous pourrez vous identifier avec votre nouveau mot de passe.';

// Update contacts
export const WLOST_500 = 'Protéger votre compte';
export const WLOST_501 = 'Vos moyens de contact vous permettent de réinitialiser facilement votre mot de passe en cas d\'oubli et de recevoir des notifications relatives à la sécurité de votre compte. Nous vous recommandons de les mettre à jour dès à présent.';
export const WLOST_502 = 'Valider, modifier ou compléter vos moyens de contact :';
export const WLOST_503 = 'Numéro de mobile (recommandé)';
export const WLOST_504 = 'Adresse e-mail';
export const WLOST_505 = 'N° de mobile invalide';
export const WLOST_506 = 'Adresse email invalide';
export const WLOST_507 = 'Renseignez une adresse e-mail';
export const WLOST_512 = 'Adresse email inconnue';

// Alert message contact
export const WLOST_513 = 'Renseignez si possible une adresse e-mail autre qu\'Orange pour réinitialiser plus facilement votre mot de passe. Sinon, continuez avec l\'adresse e-mail Orange affichée.';
export const WLOST_520 = 'Sans moyen de contact, si votre mobile est volé ou perdu, vous ne serez plus en mesure de réinitialiser le mot de passe pour accéder à vos services d’Orange.';
export const WLOST_521 = 'Un second moyen de contact facilite la réinitialisation du mot de passe de votre compte.';

// Confirmation
export const WLOST_600 = 'Félicitations, votre mot de passe est enregistré.';
export const WLOST_601 = 'Pour accéder à votre compte et services Orange, identifiez-vous.';
export const WLOST_602 = 'Pour accéder à votre compte et services Orange, identifiez-vous.';
export const WLOST_603 = 'S’identifier';
export const WLOST_604 = 'Votre mot de passe est strictement confidentiel.\nNe le communiquez à personne : ni verbalement, ni par email, ni par SMS.\nLe service clients Orange ne vous demandera jamais cette information.';

// Phising
export const WLOST_610 = 'Plus d’info sur le phishing';

// Popin
export const WLOST_620 = 'Votre avis nous intéresse';
export const WLOST_621 = 'Comment s\'est passé la modification de votre mot de passe ?\nDonnez votre avis et tentez de gagner un iPhone 11.';
export const WLOST_622 = 'Répondre au questionnaire';

// Common
export const WBUTTON_001 = 'Continuer';
export const WBUTTON_002 = 'Valider';
export const WBUTTON_003 = 'Terminer';
export const WBUTTON_004 = 'Retour';
export const WBUTTON_005 = 'Recommencer';

// Errors
export const WLOST_700 = 'Un problème technique est survenu sur cette page.';
export const WLOST_701 = 'Veuillez réessayer dans quelques instants.';
